/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var pointOnFeature = _interopDefault(require('@turf/point-on-feature'));
var consts = require('./consts');

/**
 * @param {number|number[]} lonOrCoordinates
 * @param {number} [lat]
 * @return {ol.geom.Point}
 */
var GeometryCollection = __ol__.geom.GeometryCollection;
var LineString = __ol__.geom.LineString;
var MultiLineString = __ol__.geom.MultiLineString;
var MultiPoint = __ol__.geom.MultiPoint;
var MultiPolygon = __ol__.geom.MultiPolygon;
var Point = __ol__.geom.Point;
var Polygon = __ol__.geom.Polygon;
var Circle = __ol__.geom.Circle;
function createPointGeom(lonOrCoordinates, lat) {
  var coordinates = Array.isArray(lonOrCoordinates) ? lonOrCoordinates : [lonOrCoordinates, lat];

  return new Point(coordinates);
}

/**
 * @param {Array<number[]>} points
 * @returns {ol.geom.LineString}
 */
function createLineGeom(points) {
  return new LineString(points);
}

/**
 * @param {Array<Array<number[]>>} rings
 * @returns {ol.geom.Polygon}
 */
function createPolygonGeom(rings) {
  return new Polygon(rings);
}

/**
 * @param {Array<number[]>} points
 * @returns {ol.geom.MultiPoint}
 */
function createMultiPointGeom(points) {
  return new MultiPoint(points);
}

/**
 * @param {Array<Array<number[]>>} lines
 * @returns {ol.geom.MultiLineString}
 */
function createMultiLineGeom(lines) {
  return new MultiLineString(lines);
}

/**
 * @param {Array<Array<Array<number[]>>>} polygons
 * @returns {ol.geom.MultiPolygon}
 */
function createMultiPolygonGeom(polygons) {
  return new MultiPolygon(polygons);
}

/**
 * @param {ol.geom.Geometry[]} geoms
 * @returns {ol.geom.GeometryCollection}
 */
function createGeomCollection(geoms) {
  return new GeometryCollection(geoms);
}

/**
 * @param {ol.Coordinate|number[]} center
 * @param {number} radius
 * @return {ol.geom.Polygon}
 */
function createCircularPolygon(center, radius) {
  return Polygon.circular(consts.WGS84_SPHERE, center, radius);
}

/**
 * @param {ol.geom.Geometry|GeoJSONGeometry} geom
 * @return {boolean}
 * @throws {Error}
 */
function isMultiGeom(geom) {
  var multiTypes = [consts.GEOMETRY_TYPE.MULTI_POINT, consts.GEOMETRY_TYPE.MULTI_LINE_STRING, consts.GEOMETRY_TYPE.MULTI_POLYGON, consts.GEOMETRY_TYPE.GEOMETRY_COLLECTION];

  return multiTypes.includes(geom.type || geom.getType());
}

/**
 * @param {ol.geom.Geometry|GeoJSONGeometry} geom
 * @return {ol.geom.SimpleGeometry|GeoJSONGeometry}
 * @throws {Error}
 */
function toSimpleGeom(geom) {
  if (geom instanceof Circle) {
    geom = createPointGeom(geom.getCenter());
  }

  var type = geom.type || geom.getType();
  var complexTypes = [consts.GEOMETRY_TYPE.GEOMETRY_COLLECTION];

  if (complexTypes.includes(type) === false) {
    return geom;
  }

  return (geom.geometries || geom.getGeometries())[0];
}

/**
 * @param {ol.geom.Geometry|GeoJSONGeometry} geom
 * @return {ol.Coordinate|undefined}
 */
function findPointOnSurface(geom) {
  var simpleGeom = toSimpleGeom(geom);
  var pointFeature = pointOnFeature({
    type: simpleGeom.type || simpleGeom.getType(),
    coordinates: simpleGeom.coordinates || simpleGeom.getCoordinates()
  });

  if (pointFeature && pointFeature.geometry) {
    return pointFeature.geometry.coordinates;
  }
}

exports.createPointGeom = createPointGeom;
exports.createLineGeom = createLineGeom;
exports.createPolygonGeom = createPolygonGeom;
exports.createMultiPointGeom = createMultiPointGeom;
exports.createMultiLineGeom = createMultiLineGeom;
exports.createMultiPolygonGeom = createMultiPolygonGeom;
exports.createGeomCollection = createGeomCollection;
exports.createCircularPolygon = createCircularPolygon;
exports.isMultiGeom = isMultiGeom;
exports.toSimpleGeom = toSimpleGeom;
exports.findPointOnSurface = findPointOnSurface;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/geom.js
// module id = 104
// module chunks = 1